import { render } from "./QRreader.vue?vue&type=template&id=79418510&scoped=true"
import script from "./QRreader.vue?vue&type=script&lang=js"
export * from "./QRreader.vue?vue&type=script&lang=js"

import "./QRreader.vue?vue&type=style&index=0&id=79418510&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79418510"

export default script